
import { reactive} from "vue";
import DynamicForm from "@/components/Shared/Dynamicform/DynamicForm.vue";

export default {
  name: "WildBookEntryAnimalExtension",
  inheritAttrs: false,
  components: {
    DynamicForm
  },
  setup() {
    const request = reactive({
      apiLoadMethod: "",
      apiSaveMethod: "api/sync/syncWildbook",
      form: "WildbuchEintragJagd",
      page: "WildbuchEintragTierartZusatzJagd",
      remoteId: "",
      
      

    });
    return {
      request
    };
  }
};
